import React from 'react';

import styled from 'styled-components';
import { prop } from 'styled-tools';

import ComparisonRow from 'components/ComparisonRow';

import { TabTableColumnI, TabTableHeaderI } from 'interfaces/content-stack/modular-blocks/tabTable';

import { buildComparisonRows } from 'utils/functions';

const Table = styled.div`
  display: block;
  font-weight: 400;
  padding-bottom: 1.875rem;

  @media (min-width: ${prop('theme.breakpoints.md')}) {
    display: none;
  }
`;

interface MobileTabTableProps {
  columns: TabTableColumnI[];
  headers: TabTableHeaderI[];
}

function MobileTabTable({ columns, headers }: MobileTabTableProps) {
  const rows = buildComparisonRows(columns, headers);

  return (
    <Table>
      {rows?.map((row, index) => (
        <ComparisonRow key={`comparison_row_${index}`} firstRow={row.header} name={row.name} data={row.data} />
      ))}
    </Table>
  );
}

export default React.memo(MobileTabTable);
